module.exports = __webpack_public_path__ + "img/0Q3A8622_L_BlackMatted_MockedUp.9c7d087b.jpg";